
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artifactory",
      function () {
        return require("private-next-pages/artifactory.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artifactory"])
      });
    }
  